import React from 'react'
import {Route} from '../components/Router'

import {default as Eventlist} from '../components/canvas/events/eventlist.js';
import {default as Structure} from '../components/canvas/structure/structure.js';
import {default as Markets} from '../components/canvas/markets/markets.js';
import {default as Results} from '../components/canvas/results/results.js';
import {default as Toplists} from '../components/canvas/toplists/toplists.js';

export default function CanvasContainer(){
    return (
        <div>
            <Route path="/canvas/" exact={true} component={Eventlist} />
            <Route path="/canvas/events" exact={true} component={Eventlist} />
            <Route path="/canvas/events/:channel/:mode" exact={true} component={Eventlist} />
            <Route path="/canvas/events/:channel/:mode/:date" exact={true} component={Eventlist} />
            <Route path="/canvas/events/:channel/:mode/:date/:eventid" exact={true} component={Eventlist} />
            <Route path="/canvas/structure" exact={true} component={Structure} />
            <Route path="/canvas/structure/:channel" exact={true} component={Structure} />
            <Route path="/canvas/structure/:channel/:sport" exact={true} component={Structure} />
            <Route path="/canvas/structure/:channel/:sport/:category" exact={true} component={Structure} />
            <Route path="/canvas/structure/:channel/:sport/:category/:tournament" exact={true} component={Structure} />
            <Route path="/canvas/markets/:channel/:sport" exact={true} component={Markets} />
            <Route path="/canvas/markets/:channel/:sport/market/:market" exact={true} component={Markets} />
            <Route path="/canvas/markets/:channel/:sport/type/:type" exact={true} component={Markets} />
            <Route path="/canvas/results" exact={true} component={Results} />
            <Route path="/canvas/results/:channel" exact={true} component={Results} />
            <Route path="/canvas/results/:channel/:result" exact={true} component={Results} />
            <Route path="/canvas/toplists/" exact={false} component={Toplists} />
        </div>
    );
}